var React = require('react');

function PortfolioCarouselArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m1230 2034 16 14.57143-16 15.42857","fill":"none","stroke":"#44e3df","strokeLinecap":"square","strokeWidth":"2","transform":"translate(-1228 -2032)"}));
}

PortfolioCarouselArrow.defaultProps = {"height":"34","viewBox":"0 0 20 34","width":"20"};

module.exports = PortfolioCarouselArrow;

PortfolioCarouselArrow.default = PortfolioCarouselArrow;
